import { Component } from '@angular/core';
import { VALUE_PROPS} from '../../data/landing-content';

@Component({
  selector: 'landing-inversores-value-props',
  templateUrl: './landing-value-props.component.html',
  styleUrls: ['./landing-value-props.component.scss'],
})
export class LandingValuePropsComponent {
  readonly differentiators = VALUE_PROPS;
}
